/**
 * Version check — detecta quando uma nova versao do app foi deployada
 * enquanto o usuario ainda esta com a aba aberta, e faz hard-reload
 * com cache-bust para evitar ChunkLoadError e HTML stale.
 *
 * Fluxo:
 *  1. No boot, le /version.json (fresh) e memoriza a versao atual
 *  2. A cada INTERVAL_MS, le /version.json de novo
 *  3. Se versao mudou -> window.location.replace(url + ?_v=nova)
 *  4. Ao ficar online (online event), revalida imediatamente
 *  5. Ao voltar a ficar visivel (visibilitychange), revalida imediatamente
 */

const VERSION_URL = '/version.json';
const INTERVAL_MS = 60 * 1000; // 1 min
const MIN_RECHECK_MS = 10 * 1000; // throttle

let currentVersion = null;
let intervalId = null;
let lastCheckAt = 0;
let reloading = false;

async function fetchVersion() {
  try {
    const url = `${VERSION_URL}?_=${Date.now()}`;
    const res = await fetch(url, { cache: 'no-store', credentials: 'omit' });
    if (!res.ok) return null;
    const data = await res.json();
    return data && data.version ? String(data.version) : null;
  } catch {
    return null;
  }
}

function forceReload(newVersion) {
  if (reloading) return;
  reloading = true;
  try {
    const url = new URL(window.location.href);
    url.searchParams.set('_v', newVersion || Date.now().toString());
    // eslint-disable-next-line no-console
    console.info(`[versionCheck] Nova versao detectada (${newVersion}). Recarregando...`);
    window.location.replace(url.toString());
  } catch {
    window.location.reload();
  }
}

async function check() {
  const now = Date.now();
  if (now - lastCheckAt < MIN_RECHECK_MS) return;
  lastCheckAt = now;

  const v = await fetchVersion();
  if (!v) return;
  if (!currentVersion) {
    currentVersion = v;
    return;
  }
  if (v !== currentVersion) {
    forceReload(v);
  }
}

export function initVersionCheck() {
  if (typeof window === 'undefined') return;
  if (intervalId) return;

  // primeira leitura
  check();

  intervalId = setInterval(check, INTERVAL_MS);

  // revalida quando volta a ficar visivel ou online
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
  window.addEventListener('online', check);
}

export function stopVersionCheck() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
